<div class="fieldset content-area">
    <img src="images/workbuddy_full_logo.svg">
    <div class="description description-title">401</div>
    <div class="description description-title-small">Access denied</div>
    <div class="description">Your account does not have permission to login via the web application.</div>
    <div class="flex-auto actions">
        <button (click)="onLogin()" class="btn btn-primary">Log Out</button>
    </div>

</div>